var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/32px/medium") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/32px/medium",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "medium-brands",
    transform: "translate(4.000000, 10.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.48671875,0 C2.90421719,0 0,2.91029669 0,6.5 C0,10.0897033 2.90443281,13 6.48671875,13 C10.0690047,13 12.9734375,10.0899179 12.9734375,6.5 C12.9734375,2.9100821 10.0693641,0 6.48671875,0 Z M16.8457031,0.380762416 C15.0543984,0.380762416 13.6025234,3.12110016 13.6025234,6.5001073 C13.6025234,9.87911444 15.0546141,12.619631 16.8459187,12.619631 C18.6372234,12.619631 20.0893141,9.87929327 20.0893141,6.5001073 L20.0890625,6.5001073 C20.0890625,3.12013448 18.6371875,0.380762416 16.845775,0.380762416 L16.8457031,0.380762416 Z M21.8592,1.01814425 C21.2293594,1.01814425 20.7187234,3.4726777 20.7187234,6.5001073 C20.7187234,9.52753689 21.2290359,11.9820703 21.8592,11.9820703 C22.4893641,11.9820703 23,9.52689311 23,6.5 C23,3.47246311 22.4891484,1.01814425 21.8592719,1.01814425 L21.8592,1.01814425 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.9d1cd4a57e127cdc24ff84fd5678703e.svg";
export { ForwardRef as ReactComponent };